var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivacyBlackIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#141414",
    d: "M9 10.992h7c-.53 4.12-3.28 7.79-7 8.94v-8.93H2v-5.7l7-3.11zM8.19.362l-7 3.11C.47 3.793 0 4.513 0 5.303v4.7c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12v-4.7c0-.79-.47-1.51-1.19-1.83l-7-3.11c-.51-.23-1.11-.23-1.62 0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivacyBlackIcon);
export default __webpack_public_path__ + "static/media/privacy-black-icon.e3bd192147a1ff9f211b23d2e3bac95e.svg";
export { ForwardRef as ReactComponent };